import React from 'react';
import './FindMe.css'
import { GrInstagram } from "@react-icons/all-files/gr/GrInstagram";
import { FaLinkedin } from "@react-icons/all-files/fa/FaLinkedin";
import { FaTwitter } from "@react-icons/all-files/fa/FaTwitter";
import { FaFacebook } from "@react-icons/all-files/fa/FaFacebook";
import { SiIndeed } from "@react-icons/all-files/si/SiIndeed";
import { FaGithub } from "@react-icons/all-files/fa/FaGithub";
import { SiUpwork } from "@react-icons/all-files/si/SiUpwork";



const FindMe = () => {
    return (
        <div className="container m-3 mt-5 mb-5">
            <h4>Find Me</h4>
            <hr style={{width: '8%',height: '2px', color:'blue'}}/>
            <div className="container">
             
            <div className="row icon-area ms-3">
                <div className="col-md-2 individual-icon"><a href="https://www.linkedin.com/in/abdullahalrafee/" target="_blank"><FaLinkedin className="find-icon"/></a></div>
                <div className="col-md-2 individual-icon"><a href="https://github.com/Rafee1100" target="_blank"><FaGithub className="find-icon"/></a></div>
                <div className="col-md-2 individual-icon"><a href="https://www.facebook.com/abdullahal.rafee/" target="_blank"><FaFacebook className="find-icon"/></a></div>
                <div className="col-md-2 individual-icon"><a href="https://www.instagram.com/rafee.abdullah/" target="_blank"><GrInstagram className="find-icon"/></a></div>
                <div className="col-md-2 individual-icon"><a href="https://www.upwork.com/freelancers/~01c30eca93534605ff" target="_blank"><SiUpwork className="find-icon"/></a></div>
                <div className="col-md-2 individual-icon"><SiIndeed className="find-icon"/></div>
                
            </div>
            </div>
        </div>
    );
};

export default FindMe;